import React from 'react';
import _ from 'lodash';
import { Dimmer, Loader, Table } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import { runInAction } from 'mobx';

import { swallowError } from '../../helpers/utils';
import { isStoreError } from '../../models/BaseStore';
import ErrorBox from '../helpers/ErrorBox';

// expected props
// - environment
// - environmentsStore
class EnvironmentExtCollections extends React.Component {
  constructor(props) {
    super(props);
    this.store = props.environmentsStore;
    this.state = { showLoader: true, collections: [] };
  }

  async componentDidMount() {
    swallowError(this.store.load());
    const result = await this.store.getExtCollections(this.props.environment.id);	  
    runInAction(() => {
      this.setState({ showLoader: false, collections: result });
    });
  }

  render() {
    // Render loading, error, or button
    let content;
    if (isStoreError(this.store)) {
      content = <ErrorBox error={this.store.error} />;
    } else {
      content = this.renderExtCollectionsTable();
    }

    return content;
  }

  renderExtCollectionsTable() {
    const renderRow = collection => {
        return (
          <Table.Row key={collection.studyId}>
            <Table.Cell>{collection.studyId}</Table.Cell>
            <Table.Cell>{collection.collections}</Table.Cell>
            <Table.Cell>{collection.status}</Table.Cell>
          </Table.Row>
        );
    };

    return (
      <>
	<Dimmer.Dimmable dimmed={this.state.showLoader}>
        <Dimmer active={this.state.showLoader}>
          <Loader />
        </Dimmer>
	<Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell rowSpan="2">StudyId</Table.HeaderCell>
              <Table.HeaderCell rowSpan="2">Collection(s)</Table.HeaderCell>
              <Table.HeaderCell rowSpan="2">Status</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{_.map(this.state.collections, collection => renderRow(collection))}</Table.Body>
        </Table>    
	</Dimmer.Dimmable>    
      </>
    );
  }
}

export default observer(EnvironmentExtCollections);
